import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatCardModule } from '@angular/material/card';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import { RentRoutingModule } from './rent.routing';
import { RentSearchComponent } from './components/rent-search/rent-search.component';

import { RentHomeComponent } from './components/rent-home/rent-home.component';
import { RentDetailsComponent } from './components/rent-details/rent-details.component';
import { RentComponent } from './rent.component';

import { RentBookingComponent } from './components/rent-booking/rent-booking.component';
import { RentFleetComponent } from './components/rent-fleet/rent-fleet.component';
import { RentCarDetailsComponent } from './components/rent-car-details/rent-car-details.component';

import { RentCarBoxListComponent } from './components/rent-car-box-list/rent-car-box-list.component';
import { RentCarCardListComponent } from './components/rent-car-card-list/rent-car-card-list.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { CarSearchComponent } from '../car/elements/car-cards/car-search.component';
import { ImageCarouselComponent } from '../common/generic/image-carousel/image-carousel.component';
import { CarBoxListComponent } from '../car/elements/car-box-list/car-box-list.component';
import { CarDetailsComponent } from '../car/elements/car-details/car-details.component';
import { CarCardListComponent } from '../car/elements/car-card-list/car-card-list.component';



@NgModule({
  declarations: [
    RentComponent,
    RentHomeComponent,
    RentSearchComponent,
    RentDetailsComponent,
    RentBookingComponent,
    RentFleetComponent,
    RentCarDetailsComponent,

    RentCarBoxListComponent,
    RentCarCardListComponent
  ],
  imports: [
    RentRoutingModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    MatCardModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDividerModule,

    MatTooltipModule,
    OverlayModule,
    
    MatDatepickerModule,
    MatNativeDateModule,

    CarSearchComponent,
    ImageCarouselComponent,
    CarBoxListComponent,
    CarDetailsComponent,
    CarCardListComponent
  ]
})
export class RentModule { }
